import React, { useMemo } from "react";
import PageLayout from "layouts/PageLayout";
import SubscriptionTable from "components/SubscriptionTable/SubscriptionTable";
import SubscriptionForm from "components/SubscriptionForm/SubscriptionForm";
import TextActionButton from "components/TextActionButton/TextActionButton";
import useSubscriptions from "hooks/useSubscriptions";
import { useConfirmationDialog } from "hooks/useConfirmationDialog";

export default function ManageSubscriptions({ ...otherProps }) {
    const { openDialog, closeDialog } = useConfirmationDialog();
    const { subscriptions = [], isLoading, mutate } = useSubscriptions();

    const emptyInitialValues = useMemo(
        () => ({
            name: "",
            planDescription: "",
            setupFee: "",
            monthlyFee: "",
            cancelFee: "",
            createdAt: new Date(),
            active: true,
        }),
        []
    );

    const handleCreateSubscription = () => {
        openDialog({
            customDialog: true,
            fullWidth: true,
            maxWidth: "xs",
            message: (
                <SubscriptionForm
                    initialValues={emptyInitialValues}
                    closeDialog={closeDialog}
                    onSuccess={() => {
                        mutate();
                        closeDialog();
                    }}
                />
            ),
        });
    };

    return (
        <PageLayout
            showSelectDealer={false}
            customComponent={
                <TextActionButton onClick={handleCreateSubscription}>
                    Create Subscription
                </TextActionButton>
            }
            {...otherProps}
        >
            <SubscriptionTable
                subscriptions={subscriptions}
                isLoading={isLoading}
                mutate={mutate}
                openDialog={openDialog}
                closeDialog={closeDialog}
            />
        </PageLayout>
    );
}
